import UltMeta, { Meta } from "@/meta/UltMeta/index";

class OpenMode extends UltMeta {
    WECHAT_PAY = new Meta(1, "微信支付");
    ALIPAY = new Meta(2, "支付宝");
    ACTIVATION_CODE = new Meta(3, "激活码");
    APPLE_PAY = new Meta(4, "APPLE PAY");
}

export const OPEN_MODE = new OpenMode();
